// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"8572ebe6bb0a87a4","6831":"c04da31dabf2b1a3","8503":"8220484c5427bf4e","9683":"a63223e61b705035"}[chunkId] + ".js";
};